export const CURRENCY_SYMBOLS = { USD: "US$", AUD: "A$", NZD: "NZ$", EUR: "EUR " };

export function formatMoney(amount, currency = "AUD") {
  const value = Number(amount || 0);
  const symbol = CURRENCY_SYMBOLS[currency] || "$";
  return `${symbol}${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const STATUS_META = {
  draft: { label: "Draft", className: "bg-white text-[#5B6B7C] border border-[#C4D0DB]" },
  sent: { label: "Sent", className: "bg-[#E6F2FA] text-[#0088CC] border border-[#0088CC]" },
  accepted: { label: "Accepted", className: "bg-[#E7F6EE] text-[#10B981] border border-[#10B981]" },
  rejected: { label: "Rejected", className: "bg-[#FDECEC] text-[#EF4444] border border-[#EF4444]" },
};

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
